let id = Date.now(); // TFSID 872587 don't start from 0 because Chrome assumes same-id is same-field

export function generateUniqueId(prefix: string): string {
  return `${prefix}-${id++}`;
}